<template>
    <div class="box">
        <div class="box-title">
            <!-- 如果您想进一步了解敬在产品或解决方案 -->
            咨询敬在产品或解决方案
        </div>
        <div class="input-group">
            <span class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M17 2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 17H8V5h8v14z" />
                </svg>
            </span>
            <input type="text" v-model="inputName" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11"
                placeholder="请输入手机号">
            <button class="input-btn" @click="serveClick">预约服务</button>
        </div>
        <div class="box-footer">
            <div v-for="item in footerList" :key="item.title">
                {{ item.title }}
            </div>
        </div>
    </div>
</template>

<script>
import { config } from "../../constant/config.js";
export default {
    data() {
        return {
            inputName: '',
            footerList: [
                { title: '上门或线上产品演示', img: '', },
                { title: '企业定制化解决方案', img: '', },
                { title: '全天候业务咨询服务', img: '', },
                { title: '专业客户顾问全程服务', img: '', },
            ]
        };
    },
    mounted() { },
    methods: {
        serveClick() {
            this.$router.push({
                path: '/appointmentService',
                query: {
                    inputName: this.inputName
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
@height: 40px;

.box {
    padding: @commonPadding;
    background-color: #FFF100;
    color: #000000;
    height: 323px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* padding: 73px 240px; */

    &-title {
        font-size: 30px;
        font-weight: 400;
    }

    .input-group {
        display: flex;
        align-items: center;
        margin-top: 40px;
        border: 1px solid #ccc;
        /* 给整个组加边框，和截图一致 */
        background-color: #fff;
        /* input背景白色 */
    }

    // 前置图标样式
    .input-icon {
        padding: 0 15px;
        color: #999;
        /* 图标颜色 */
    }

    input {
        width: 750px;
        /* 调整宽度，给按钮留空间 */
        height: 57px;
        border: none;
        /* 去掉input默认边框 */
        outline: none;
        /* 去掉聚焦边框 */
        padding: 0 10px;
    }

    // 后置按钮样式
    .input-btn {
        height: 57px;
        padding: 0 20px;
        background-color: #fff;
        /* 按钮背景黑色 */
        color: #000;
        /* 按钮文字白色 */
        border: none;
        cursor: pointer;
    }

    /*
    input {
        width: 959px;
        height: 57px;
        margin-top: 40px;
    } */

    &-footer {
        margin-top: 30px;
        width: 734px;
        display: flex;
        justify-content: space-around;

    }
}


@media @mobile {
    .box {
        height: auto; // 高度自适应
        padding: 30px 20px; // 缩小内边距
        text-align: center;

        &-title {
            font-size: 24px; // 缩小标题字体
            line-height: 1.5; // 增加行高
        }

        .input-group {
            width: 100%; // 宽度铺满屏幕
            margin-top: 20px; // 缩小间距
        }

        .input-icon {
            padding: 0 10px; // 缩小图标内边距
        }

        input {
            width: 100%; // input宽度自适应
            height: 45px; // 缩小高度
            font-size: 14px; // 缩小输入框字体
        }

        .input-btn {
            height: 45px; // 按钮高度和input一致
            padding: 0 15px; // 缩小按钮内边距
            font-size: 14px; // 缩小按钮字体
            white-space: nowrap; // 防止按钮文字换行
        }

        &-footer {
            width: 100%; // 宽度铺满
            margin-top: 20px; // 缩小间距
            flex-wrap: wrap; // 允许换行
            gap: 15px 0; // 增加行间距

            div {
                width: 48%; // 每行显示2个
                font-size: 12px; // 缩小字体
                line-height: 1.4; // 增加行高
            }
        }
    }
}
</style>
